import { StatusButton } from "../../../../components/atoms";
import { Stack } from "@introist/react-foundation/v2";
import { useStoredWorkspaceState } from "hooks/use-storage-state";
import { useEffect } from "react";

interface Props {
  steps?: any[];
  onFilterChange: (statuses: string[]) => void;
}

export const AutomationStepStatuses = ({ steps, onFilterChange }: Props) => {
  const [statusFilter, setStatusFilter] = useStoredWorkspaceState<string[]>(
    "intr.automation.step.statuses",
    ["draft", "scheduled", "delivered", "failing", "completed"]
  );

  useEffect(() => {
    onFilterChange(statusFilter);
  }, [statusFilter, onFilterChange]);

  const toggleFilter = (statuses: string[]) => {
    const shouldRemove = statuses.some(s => statusFilter.includes(s));
    const next = shouldRemove
      ? statusFilter.filter(s => !statuses.includes(s))
      : [...statusFilter, ...statuses];
    setStatusFilter(next);
  };

  return (
    <Stack gap="small">
      <StatusButton
        status="draft"
        count={(steps ?? []).filter(s => s.status === "draft").length}
        active={statusFilter.includes("draft")}
        onClick={() => toggleFilter(["draft"])}
      />
      <StatusButton
        status="scheduled"
        count={(steps ?? []).filter(s => ["scheduled", "delivered"].includes(s.status)).length}
        active={statusFilter.includes("scheduled")}
        onClick={() => toggleFilter(["scheduled", "delivered"])}
      />
      <StatusButton
        status="failing"
        count={(steps ?? []).filter(s => s.status === "failing").length}
        active={statusFilter.includes("failing")}
        onClick={() => toggleFilter(["failing"])}
      />
      <StatusButton
        status="completed"
        count={(steps ?? []).filter(s => s.status === "completed").length}
        active={statusFilter.includes("completed")}
        onClick={() => toggleFilter(["completed"])}
      />
      <StatusButton
        status="canceled"
        count={(steps ?? []).filter(s => s.status === "canceled").length}
        active={statusFilter.includes("canceled")}
        onClick={() => toggleFilter(["canceled"])}
      />
    </Stack>
  );
};
